/** @format */

import React from "react";
import { Card, Row, Col, Button } from "antd";
import { Link } from "react-router-dom";
import { WarningOutlined } from "@ant-design/icons";

const PageNotFoundContent: React.FC = () => (
	<Card
		style={{
			background: "rgba(255, 255, 255, 0.8)",
			border: "1px dashed #d9d9d9",
			borderRadius: "4px",
			margin: "24px",
		}}>
		{/* style={{ width: "320px" }}> */}
		<Row justify="center" style={{ display: "flex" }}>
			<Col>
				<WarningOutlined style={{ fontSize: "16em" }} />
			</Col>
		</Row>
		<Row justify="center" style={{ marginBottom: "8px", display: "flex" }}>
			<Col>
				<span style={{ fontSize: "2.4em" }}>Page not found</span>
			</Col>
		</Row>
		<Row>
			<Col>
				<span>
					The page you are trying to reach could not be found or does not exist.
				</span>
			</Col>
		</Row>
		<Row justify="center" style={{ marginTop: "24px", display: "flex" }}>
			<Col>
				<Link to="/">
					<Button type="primary">Go to home</Button>
				</Link>
			</Col>
		</Row>
	</Card>
);

export default PageNotFoundContent;
